import _ from 'lodash';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import './css/App.css';
import * as Pages from './pages';
import React from 'react';
import {PageStore} from './stores';
import {withPage} from './hoc';
import SectionLinks from './SectionLinks';
/**
 * ApplicationRouter
 */
export default class ApplicationRouter extends React.Component {
  static displayName = 'ApplicationRouter';
  static propTypes = {};
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    _.bindAll(this, 'routes');
  }

  routes() {
    const allRoutes = _.map(PageStore.getState().Router, (page) => {
      if (!_.has(Pages, page.type)) {
        console.error('Page type', page.type, 'is not defined');
        return null;
      }
      const routeOptions = {
        key: page._id,
        path: page.relativeLink,
        component: withPage(Pages[page.type], page),
        exact: true,
      };
      if (page.type === 'TagPage') {
        const Component = routeOptions.component;
        delete routeOptions['component'];
        return {
          path: page.relativeLink,
          route: (
            <Route
              {...routeOptions}
              render={() => {
                return <Component tag={page.menuTitle} {...this.props} />;
              }}
            />
          ),
        };
      }

      return {
        path: page.relativeLink,
        route: <Route {...routeOptions} />,
      };
    })

    return allRoutes.filter(Boolean);
  }

  /**
   * @override
   */
  render() {
    const forceRefresh = _.isNil(window.history.pushState);
    const SectionPage = Pages['SectionPage'];
    return (
      <Router forceRefresh={forceRefresh}>
        <Switch>
          {_.map(
            _.orderBy(
              this.routes(),
              ['path'], // Sort by first (path)
              ['desc']
            ),
            'route'
          )}
          {_.map(SectionLinks, (path, name, index) =>
            <Route
              key={'section' + index}
              path={path}
              render={() => <SectionPage section={name} />}
            />
          )}

          <Route path="/years/:year" render={(props) => {
                return <Pages.TagPage  key={props.match.params.year} tag="Actualités" currentPage="ActuYear" {...this.props} />;
            }} />
          <Route path="/Security/*" component={Pages.Login} />
          <Route component={Pages.Error404} />
        </Switch>
      </Router>
    );
  }
}
